import React, { useEffect, useState } from "react";
import { Icons, Box } from "@curves/ui-base";
import clsx from "clsx";
import { SpecialConditionDialog } from "@icoach/memberDetail/dialog";

const SpecialConditionBox = props => {
	const { className, textEllipsisColumns = 2, width = "18rem", isTableSpace = true, sourceData } = props;
	const { memberID, value } = sourceData;
	const [specialCondition, setSpecialCondition] = useState("");
	const [open, setOpen] = React.useState(false);
	const whiteSpaceNormal = isTableSpace ? "white-space-normal" : "";

	const handleCloseDialog = () => {
		setOpen(false);
	};

	const handleOpenDialog = () => {
		setOpen(true);
	};

	const doRefresh = notes => {
		setSpecialCondition(notes);
		const { setSourceDataById } = props;
		if (typeof setSourceDataById === "function") {
			setSourceDataById(memberID, { specialCondition: notes });
		}
	};

	useEffect(
		() => {
			if (value || value !== specialCondition) {
				setSpecialCondition(value);
			}
			return () => {
				setOpen(false);
			};
		},
		// eslint-disable-next-line
		[value]
	);

	return (
		<React.Fragment>
			<Box className={clsx(["special-condition-box", "cursor-pointer", `text-ellipsis-columns-${textEllipsisColumns}`, className])} style={{ width }} onClick={handleOpenDialog}>
				<Box className={clsx(whiteSpaceNormal)}>{specialCondition.length > 0 ? specialCondition : <Icons.Edit className={"special-condition-box__icon"} htmlColor={"#d3d2d1"} />}</Box>
			</Box>
			<SpecialConditionDialog open={open} onClose={handleCloseDialog} sourceData={{ memberID, specialCondition }} refresh={doRefresh} />
		</React.Fragment>
	);
};

export default SpecialConditionBox;
